export const PAGE_NAME = 'gig_page';
export const SINGLE_PACKAGE = 'single';
export const TRIPLE_PACKAGE = 'triple';
export const GIG_GALLERY = 'gig_gallery';
export const GIG_SUB_HEADER = 'gig_sub_header';
export const GIG_NAV_MENU = 'gig_navigation_menu';
